module.exports = new __parcel__URL__("pt_3.7cd5ed24.png").toString();